'use client';

import { ReactNode } from 'react';

import AppHeader from '../containers/AppHeader/AppHeader';
import AppFooter from '../containers/AppFooter/AppFooter';
import { PropsWithLang } from '@/types/types';
import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { TypeMegaMenuComponentWithoutUnresolvableLinksResponse } from '@/features/contentful/_generated';
import { TEntriesResponse } from '@/features/contentful/types/types';
import { config } from '@/config';

type LayoutProps = {
    children: ReactNode;
    megaMenu: TEntriesResponse<TypeMegaMenuComponentWithoutUnresolvableLinksResponse[]>;
    footerData: TypeMegaMenuComponentWithoutUnresolvableLinksResponse;
} & PropsWithLang;

export default function OpenAccessLayout({
    children,
    lang,
    megaMenu,
    footerData,
}: Readonly<LayoutProps>) {
    const liveMegaMenu = useContentfulLiveUpdates(megaMenu);
    const liveFooterMenu = useContentfulLiveUpdates(footerData);

    return (
        <>
            <AppHeader lang={lang ?? config.language.default!} megaMenu={liveMegaMenu} />
            {children}
            <AppFooter lang={lang ?? config.language.default!} footerData={liveFooterMenu} />
        </>
    );
}
